import { Routes, Route } from 'react-router-dom';
import { Dashboard } from './components/Dashboard/Dashboard';
import { VideoPage } from './components/Video/VideoPage';
import { SidebarLayout } from './SidebarLayout';
import { TagsPage } from './components/Tags/TagsPage';
import { AuthorsPage } from './components/Authors/AuthorsPage';
import { SearchPage } from './components/Search/SearchPage';

export const AppRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<SidebarLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="videos" element={<VideoPage />} />
        <Route path="tags" element={<TagsPage/>} />
        <Route path="authors" element={<AuthorsPage/>} />
        {/* <Route path="popular" element={<div>Популярное (в разработке)</div>} /> */}
        <Route path="search" element={<SearchPage></SearchPage>} />
      </Route>
    </Routes>
  );
};